import { CreateApprovalRequest, UpdateApprovalRequest } from '@abovo/shared-models';
import { MAT_DIALOG_TYPES } from '@abovo/shared-ui-components';
import { ApprovalRequestStore } from '@abovo/webvis-data-access';
import { inject, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApprovalRequestDialogComponent, ApprovalRequestDialogData } from '../components/approval-request-dialog/approval-request-dialog.component';

export function useApprovalRequest() {
   const dialog = inject(MatDialog);
   const approvalRequestStore = inject(ApprovalRequestStore);
   // The dialog content (status badge) reads the route-provided ApprovalRequestStore, which the root injector does not know
   const injector = inject(Injector);

   return (data: ApprovalRequestDialogData) => {
      const getAction = (approvalRequest: CreateApprovalRequest | UpdateApprovalRequest | { approved: boolean; comment?: string }) => {
         if ('approved' in approvalRequest) {
            const approvalRequestId = data.approvalRequest?.id;

            if (!approvalRequestId) {
               return Promise.resolve(false);
            }

            return approvalRequest.approved
               ? approvalRequestStore.approve(approvalRequestId, approvalRequest)
               : approvalRequestStore.reject(approvalRequestId, approvalRequest as { approved: boolean; comment: string });
         }
         return 'id' in approvalRequest ? approvalRequestStore.update(approvalRequest) : approvalRequestStore.create(approvalRequest);
      };
      const approvalRequestDialog = dialog.open(ApprovalRequestDialogComponent, {
         ...MAT_DIALOG_TYPES.largest,
         disableClose: true,
         data,
         injector,
      });

      const approvalRequest = new Promise<CreateApprovalRequest | null>((resolve) => {
         approvalRequestDialog.componentInstance.save.subscribe(async (approvalRequest) => {
            approvalRequestDialog.componentInstance.saving.set(true);

            const action = getAction(approvalRequest);
            action.then((result) => {
               if (result) {
                  approvalRequestDialog.close();
               }
               approvalRequestDialog.componentInstance.saving.set(false);
            });
         });

         approvalRequestDialog.afterClosed().subscribe(() => resolve(null));
      });

      return {
         dialog: approvalRequestDialog,
         approvalRequest,
      };
   };
}
